<div class="face-compare-toolbar" *ngIf="hasImages">
  <div class="toolbar-container">
    <div class="toolbar-left">
      <button
        class="nav-button split-view"
        type="button"
        (click)="openSplitView()"
      >
        <i class="bi bi-grid-3x3-gap nav-icon"></i>
        <span>Split View</span>
      </button>
    </div>

    <div class="toolbar-right">
      <button class="nav-button view-uploads" type="button" (click)="toggleViewUploads()">
        <i class="bi bi-images nav-icon"></i>
        <span>Session Uploads</span>
      </button>
      <button class="nav-button reset-all" type="button" (click)="resetAll()">
        <i class="bi bi-arrow-clockwise nav-icon"></i>
        <span>Reset All</span>
      </button>
    </div>
  </div>
</div>
